import $ from 'jquery';
export default {
  namespaced: true,
  state: {
    customerContact: null,
    isShowEditText: null,
  },
  mutations: {
    SET_ACTIVE_CONTACT_CUSTUMER(state, customer) {
      if (customer) {
        window.parent.postMessage({ OpenContact: customer.custId }, '*');
        $('body, html').animate({ scrollTop: 1500 }, 'slow');
        state.customerContact = customer;
        state.isShowEditText = false;
      } else {
        state.customerContact = null;
      }
    },
    SET_NAME_CUSTUMER(state, name) {
      state.customerContact.custNameNew = name;
    },
    SET_SHOWEDIT(state, isShow) {
      state.isShowEditText = isShow;
    },
  },
  actions: {
    setActiveContactCustumer({ commit }, customer) {
      commit('SET_ACTIVE_CONTACT_CUSTUMER', null);
      setTimeout(() => {
        commit('SET_ACTIVE_CONTACT_CUSTUMER', customer);
      }, 500);
    },
    saveContactCustumer({ commit }, text) {
      commit('SET_NAME_CUSTUMER', text);
      commit('SET_SHOWEDIT', false);
    },
    setIsShowEdit({ commit }, isShow) {
      commit('SET_SHOWEDIT', isShow);
    },
  },
  getters: {
    customerContact: state => {
      return state.customerContact;
    },
    isShowEditText: state => {
      return state.isShowEditText;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Contact.js